const Characters = () => (
  <h1>Characters</h1>
);

export default Characters;
